module.exports = __webpack_public_path__ + "static/img/HistoryGroupPic_2.png";